export function clearNotifications(applicationSettings) {
    if (applicationSettings.notifications) {
        applicationSettings.notifications.error = {};
        applicationSettings.notifications.success = {};
        applicationSettings.notifications.warning = {};
    }
}
